import { State } from 'state'

export const selectTemplateFormErrors = (state: State) => state.errors.templateForm
